module.exports = __webpack_public_path__ + "static/img/Employment_Resources_Icon.4d27045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modules/icons/Employment_Resources_Icon.png
// module id = ev3Y
// module chunks = 0